import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { lastValueFrom } from 'rxjs';
import { ItOpsControllerService } from 'src/app/admin-api/api/itOpsController.service';
import { IntegrityCategory } from 'src/app/admin-api/model/integrityCategory';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-integrity-category-form',
  templateUrl: './integrity-category-form.component.html',
  styleUrls: ['./integrity-category-form.component.scss'],
  providers: [MessageService]
})
export class CategoryFormComponent implements OnInit, OnChanges {
  @Input() categoryId: number | null = null;
  @Output() saved = new EventEmitter<void>();
  categoryForm!: FormGroup;

  loading = false;
  get isEdit() {
    return !!this.categoryId;
  }

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private api: ItOpsControllerService
  ) {}

  ngOnInit(): void {
    this.categoryForm = this.fb.group({
      integrityCategoryName: ['', Validators.required]
    });
    if (this.isEdit) this.loadCurrentName();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['categoryId'] && !changes['categoryId'].firstChange) {
      if (this.isEdit) this.loadCurrentName();
      else this.categoryForm.reset();
    }
  }

  private async loadCurrentName() {
    if (!this.categoryId) return;
    try {
      LoaderService.showLoader();
      const list: IntegrityCategory[] = await lastValueFrom(
        this.api.getAllCategories()
      );
      const c = list?.find(
        (x) => (x as any).integrityCategoryId === this.categoryId
      );
      this.categoryForm.patchValue({
        integrityCategoryName: c?.integrityCategoryName ?? ''
      });
    } catch (err) {
      AppDialogService.showErrorDialog(err);
    } finally {
      LoaderService.showLoader(false);
    }
  }

  isInvalid(name: string): boolean {
    const c = this.categoryForm.get(name);
    return !!(c && c.invalid && (c.dirty || c.touched));
  }

  async submit() {
    if (this.categoryForm.invalid) {
      this.categoryForm.markAllAsTouched();
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Preencha o nome da categoria.'
      });
      return;
    }
    const body = {
      integrityCategoryName: this.categoryForm.value.integrityCategoryName
    };
    this.loading = true;

    const req$ = this.isEdit
      ? this.api.updateCategory(body, this.categoryId!)
      : this.api.createCategory(body);

    try {
      LoaderService.showLoader();
      await lastValueFrom(req$);
      this.messageService.add({
        severity: 'success',
        summary: 'Sucesso',
        detail: this.isEdit ? 'Categoria atualizada.' : 'Categoria criada.'
      });
      this.saved.emit();
      this.categoryForm.reset();
    } catch (err) {
      AppDialogService.showErrorDialog(err);
    } finally {
      this.loading = false;
      LoaderService.showLoader(false);
    }
  }
}